import React from 'react';
import { IconUser, IconBarbell, IconHome, IconTrophy } from '@tabler/icons-react';

const entityIcon = {
  admin: (size = 16) => <IconUser size={size} />,
  athlete: (size = 16) => <IconUser size={size} />,
  home: (size = 16) => <IconHome size={size} />,
  exercise: (size = 16) => <IconBarbell size={size} />,
  workout: (size = 16) => <IconBarbell size={size} />,
  achievement: (size = 16) => <IconTrophy size={size} />,
};

export default entityIcon;
